<template>
    <CardToggle :title="$t('player.layout.footer')">
        <div class="space-y-5">
            <FormToggleSm :title="$t('player.layout.display_footer')" v-model="player.showFooter" />
            <FormInput
                id="playerFooterText"
                :title="$t('player.layout.rights_reserved_label')"
                :placeholder="$t('player.layout.company_name')"
                v-model="player.footerText"
            />
            <FormInput
                id="playerFooterPolicy"
                :title="$t('player.layout.privacy_policy')"
                :placeholder="$t('player.layout.policy_placeholder')"
                v-model="player.footerPolicy"
            />
            <FormInput
                id="playerFooterTerms"
                :title="$t('player.layout.terms')"
                :placeholder="$t('player.layout.terms_placeholder')"
                v-model="player.footerTerms"
            />
        </div>
    </CardToggle>
</template>

<script>
import { mapState } from "vuex";

import { CardToggle } from "@easy/ui/cards";
import { FormToggleSm, FormInput } from "@easy/ui/forms";
import { useFocusOnQueryField } from "@/shared/utils/forms/useFocusOnQueryField";

export default {
    components: {
        CardToggle,
        FormToggleSm,
        FormInput,
    },
    setup() {
        useFocusOnQueryField();
    },
    computed: {
        ...mapState("player", ["player"]),
    },
};
</script>
